<ngx-mat-timepicker-face [color]="color"
                     [faceTime]="minutesList"
                     [selectedTime]="selectedMinute"
                     [minutesGap]="minutesGap"
                     (timeChange)="minuteChange.next($event)"
                     [unit]="timeUnit.MINUTE"></ngx-mat-timepicker-face>
